import { FC, ReactNode } from "react";
import { Table, TablePaginationConfig, Typography } from "antd";
import { StyledTag, StyledTable } from "./styled";
import { EApproveStatus } from "../../types";

interface IProps {
  pagination: false | TablePaginationConfig | undefined;
  data: {
    key: React.Key;
    version: number;
    docs: string[];
    createdAt: string;
    approvedAt: string;
    status: EApproveStatus;
    open: ReactNode;
  }[];
}

export const TableDoc: FC<IProps> = ({ data, pagination }) => {
  const { Column } = Table;
  
  return (
    <StyledTable scroll={{ y: '30vh'  }} pagination={pagination} dataSource={data}>
      <Column
        width={"7%"}
        align="right"
        title="Версия"
        dataIndex="version"
        key="version"
        render={(version: string) => (
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              color: "#4A5368",
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            {version}
          </Typography.Title>
        )}
      />

      <Column
        width={"37%"}
        align="left"
        title="Документ"
        dataIndex="docs"
        key="docs"
        render={(docs: string[]) =>
          docs.map((doc) => (
            <Typography.Title
              level={5}
              style={{
                margin: 0,
                color: "#007BFB",
                fontSize: "12px",
                fontWeight: "400",
              }}
            >
              {doc}
            </Typography.Title>
          ))
        }
      />

      <Column
        width={"12%"}
        title="Дата загрузки"
        dataIndex="createdAt"
        key="createdAt"
        render={(createdAt: string) => (
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              color: "#4A5368",
              fontSize: "12px",
              fontWeight: "400",
            }}
          >
            {createdAt}
          </Typography.Title>
        )}
      />

      <Column
        width={"14%"}
        title="В производстве работ"
        dataIndex="approvedAt"
        key="approvedAt"
        render={(approvedAt: string) => (
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              color: "#4A5368",
              fontSize: "12px",
              fontWeight: "400",
            }}
          >
            {approvedAt}
          </Typography.Title>
        )}
      />

      <Column
        width={"13%"}
        title="Статус подрядчика"
        dataIndex="status"
        key="status"
        render={(status: EApproveStatus) => (
          <StyledTag color={"#6A7695"} $textColor={"#FFFFFF"}>
            {status ? "Принято" : "Ожидание"}
          </StyledTag>
        )}
      />

      <Column
        align="left"
        title=""
        dataIndex="open"
        key="open"
        render={(open: string) => (
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              color: "#007BFB",
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            {open}
          </Typography.Title>
        )}
      />
    </StyledTable>
  );
};
